export enum $comment {
  _id = '_id',
  version = 'version',
  type = 'type',
  createdAt = 'createdAt',
  updatedAt = 'updatedAt',
  user = 'user',
  tenantId = 'tenantId',
  edited = 'edited',
}

export enum $designReviewFindingActivity {
  designReviewFindingId = 'designReviewFindingId',
  designReviewPageId = 'designReviewPageId',
  designReviewProjectId = 'designReviewProjectId',
  comments = 'comments',
  task = 'task',
  statusUpdates = 'statusUpdates',
  historyChanges = 'historyChanges',
}

export enum $designReviewFindingComment {
  message = 'message',
  designReviewFindingId = 'designReviewFindingId',
  designReviewPageId = 'designReviewPageId',
  designReviewProjectId = 'designReviewProjectId',
}

export enum $manualAuditIssueComment {
  message = 'message',
  screenshot = 'screenshot',
  recommendation = 'recommendation',
  digitalProperty = 'digitalProperty',
  manualAuditFindingId = 'manualAuditFindingId',
  manualAuditIssueId = 'manualAuditIssueId',
  deletedAt = 'deletedAt',
  newManualAuditIssueStatus = 'newManualAuditIssueStatus',
  internal = 'internal',
  deletedByUserId = 'deletedByUserId',
  deletedByUserGroups = 'deletedByUserGroups',
  deletedByUserGroupsIds = 'deletedByUserGroupsIds',
  flagReason = 'flagReason',
}

export enum ManualFindingFlagReason {
  falsePositive = 'falsePositive',
  incorrectInformationOrGuidance = 'incorrectInformationOrGuidance',
  incompleteWorkActualResult = 'incompleteWorkActualResult',
  incompleteWorkGeneral = 'incompleteWorkGeneral',
  incompleteWorkRecommendation = 'incompleteWorkRecommendation',
  incompleteWorkScreenshot = 'incompleteWorkScreenshot',
  incompleteWorkStepsToReproduce = 'incompleteWorkStepsToReproduce',
  incompleteWorkUserImpact = 'incompleteWorkUserImpact',
  misclassificationCriteriaOrRule = 'misclassificationCriteriaOrRule',
  spellingAndGrammar = 'spellingAndGrammar',
  unreportedIssues = 'unreportedIssues',
  other = 'other',
}

export enum $taskCreateComment {
  taskProjectId = 'taskProjectId',
  projectId = 'projectId',
  taskId = 'taskId',
}

export enum $taskDeleteComment {
  taskProjectId = 'taskProjectId',
}

export enum commentType {
  designReviewFindingComment = 'designReviewFindingComment',
  manualAuditIssueComment = 'manualAuditIssueComment',
  taskCreate = 'taskCreate',
  taskDelete = 'taskDelete',
  taskCreateDE = 'taskCreateDE',
  taskDeleteDE = 'taskDeleteDE',
  addFlag = 'addFlag',
  removeFlag = 'removeFlag',
}

export const currentCommentVersion: number = 0;
